import { __exports as t } from "../../../../../../../../_virtual/custom-sanitizers.js";
var o;
function d() {
  return o ? t : (o = 1, (function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var i = {
      iframe: {
        // This list should match the one in interblocks.ts https://github.com/intercom/interblocks.ts/blob/2ce1fc14f7b05b15f44bc763c675953f1c90373a/src/compile/validations.ts#L76
        src: [/^(https:)?\/\/www\.youtube(-nocookie)?\.com\/embed\/.+/, /^(https:)?\/\/www\.loom\.com\/embed\/.+/, /^(https:)?\/\/play\.vidyard\.com\//, /^(https:)?\/\/player\.vimeo\.com\/video\/.+/, /^(https:)?\/\/fast\.wistia\.(net|com)\/embed\/iframe\/.+/, /^(https:)?\/\/players\.brightcove\.net\/.+/, /^(https:)?\/\/content\.jwplatform\.com\/players\/.+/, /^(https:)?\/\/web\.microsoftstream\.com\/embed\/video\/.+/, /^(https:)?\/\/([\w-]+)\.sharepoint\.com\/:v:\/.+/, /^(https:)?\/\/share\.synthesia\.io\/embeds\/videos\/.+/, /^(https:)?\/\/embed\.app\.guidde\.com\/playbooks\/.+/, /^(https:)?\/\/share\.descript\.com\/embed\/.+/]
      }
    }, a = {
      IFRAME: function(r, p) {
        var s = r.attributes.src;
        (!s || !i.iframe.src.some(function(m) {
          return m.test(s.value);
        })) && r.remove();
      }
    };
    e.default = a;
  })(t), t);
}
export {
  d as __require
};
